import {
  useEffect,
  useState,
} from 'react';

export const useIsDesktop = (breakpoint = 1440): boolean => {
  const [
    isDesktop,
    setIsDesktop,
  ] = useState(() => (typeof window !== 'undefined' ?
    window.innerWidth >= breakpoint :
    false));

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= breakpoint);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isDesktop;
};
